import { render, staticRenderFns } from "./SaveAndShare.vue?vue&type=template&id=4a86f7c4"
import script from "./SaveAndShare.vue?vue&type=script&lang=js"
export * from "./SaveAndShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a86f7c4')) {
      api.createRecord('4a86f7c4', component.options)
    } else {
      api.reload('4a86f7c4', component.options)
    }
    module.hot.accept("./SaveAndShare.vue?vue&type=template&id=4a86f7c4", function () {
      api.rerender('4a86f7c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/accounts/SaveAndShare.vue"
export default component.exports